/**
 * Le **lien de connexion d'un scénario de recette** (vitrine seulement, `apps/api/src/acceptance/`).
 *
 * L'API ouvre la session du bureau en posant son cookie ; celle de la tablette ne vit pas dans un
 * cookie mais en IndexedDB (D22), avec un refresh livré dans un corps de réponse (D3). L'API
 * redirige donc ici en confiant le lien dans le **fragment** (`#recette=<jeton>`) — que le
 * navigateur n'envoie jamais au serveur du front — et la tablette l'échange elle-même contre sa
 * session au démarrage (`signInWithLink`).
 */
const FRAGMENT_KEY = 'recette'

/**
 * Lit le jeton du fragment et **l'efface de l'adresse** : un rechargement ne doit pas rejouer un
 * lien déjà échangé, et l'adresse affichée ne doit pas le garder. `null` sans lien.
 */
export function takeAcceptanceLinkToken(
  location: Pick<URL, 'hash' | 'pathname' | 'search'>,
  history: { replaceState(state: unknown, unused: string, url: string): void },
): string | null {
  const token = new URLSearchParams(location.hash.replace(/^#/, '')).get(FRAGMENT_KEY)
  if (!token) return null

  history.replaceState(null, '', `${location.pathname}${location.search}`)

  return token
}
